import { reactive } from 'vue';
import ConversationToolsAPI from 'custom/api/conversationTools';

// Fork inbox options (reply lock, signature), cached per inbox for the session
const cache = reactive({});
const pending = {};

export function useInboxSettings() {
  const fetchSettings = async (inboxId, { force = false } = {}) => {
    if (!inboxId) return null;
    if (cache[inboxId] && !force) return cache[inboxId];
    pending[inboxId] ||= ConversationToolsAPI.inboxSettings(inboxId)
      .then(({ data }) => {
        cache[inboxId] = data.settings;
        return data.settings;
      })
      .finally(() => {
        delete pending[inboxId];
      });
    return pending[inboxId];
  };

  const saveSettings = async (inboxId, settings) => {
    const { data } = await ConversationToolsAPI.updateInboxSettings(
      inboxId,
      settings
    );
    cache[inboxId] = data.settings;
    return data.settings;
  };

  return {
    settingsFor: inboxId => cache[inboxId],
    fetchSettings,
    saveSettings,
  };
}
